import React, { useEffect, useState, useCallback } from 'react'; 
import { Menu, MenuItemLink, fetchUtils, useNotify } from 'react-admin';
import { Chip } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import CarIcon from '@mui/icons-material/DirectionsCar';
import ReportIcon from '@mui/icons-material/Report';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import SettingsIcon from '@mui/icons-material/Settings';
import { useSocket } from './SocketContext';
import { API_URL } from './config';
import LoyaltyIcon from '@mui/icons-material/Loyalty';

const CustomMenu = () => {
    const [counts, setCounts] = useState({});
    const notify = useNotify();
    const socket = useSocket();

    // Hook لجلب الأرقام الأولية عند تحميل الصفحة
    // دالة لجلب الأرقام بشكل متكرر
    const fetchCounts = useCallback(() => {
        const token = localStorage.getItem('token');
        if (!token) return;
        
        const options = {
            headers: new Headers({ 
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            }),
        };
        
        fetchUtils.fetchJson(`${API_URL}/admin/unread-counts/unread-counts`, options)
            .then(({ json }) => {
                if (json && json.length > 0) {
                    setCounts(json[0]);
                }
            })
            .catch(() => {
                notify('Could not load sidebar counts', { type: 'warning' });
            });
    }, [notify]);

    // Hook لجلب الأرقام الأولية عند تحميل الصفحة
    useEffect(() => {
        fetchCounts();
    }, [fetchCounts]);

    // Hook للاستماع للأحداث الحية من السيرفر
    useEffect(() => {
        if (!socket) return;

        // الأحداث الفعلية التي يرسلها السيرفر
        const eventsToListen = ['new_verification_request', 'new_report'];

        // عند سماع أي حدث، أعد جلب الأرقام
        const handleRefreshCounts = (data) => {
            console.log(`[Socket] Received event, refreshing counts...`, data);
            fetchCounts(); 
        };

        // ربط المستمعين
        eventsToListen.forEach(event => {
            socket.on(event, handleRefreshCounts);
        });

        // دالة التنظيف
        return () => {
            eventsToListen.forEach(event => {
                socket.off(event, handleRefreshCounts);
            });
        };
    }, [socket, fetchCounts]);

    const MenuChip = ({ count }) => {
        if (!count || count === 0) return null;
        return <Chip label={count} color="secondary" size="small" sx={{ marginLeft: 'auto' }} />;
    };

    return (
        <Menu>
            <MenuItemLink to="/" primaryText="Dashboard" leftIcon={<DashboardIcon />} />
            <MenuItemLink to="/users" primaryText="Users" leftIcon={<PeopleIcon />} rightIcon={<MenuChip count={counts.users} />} />
            <MenuItemLink to="/verifications" primaryText="Verifications" leftIcon={<CheckCircleIcon />} rightIcon={<MenuChip count={counts.verifications} />} />
            <MenuItemLink to="/verified-users" primaryText="Verified Users" leftIcon={<VerifiedUserIcon />} />
            <MenuItemLink to="/verified-cars" primaryText="Verified Cars" leftIcon={<VerifiedUserIcon />} />
            <MenuItemLink to="/rides" primaryText="Rides" leftIcon={<CarIcon />} />
            <MenuItemLink to="/reports" primaryText="Reports" leftIcon={<ReportIcon />} rightIcon={<MenuChip count={counts.reports} />} />
            <MenuItemLink to="/support-chats" primaryText="Support Chats" leftIcon={<SupportAgentIcon />} rightIcon={<MenuChip count={counts['support-chats']} />} />
            <MenuItemLink to="/promo-codes" primaryText="Promo Codes" leftIcon={<LoyaltyIcon />} />
            <MenuItemLink to="/config/app-settings" primaryText="App Settings" leftIcon={<SettingsIcon />} />
        </Menu>
    );
};

export default CustomMenu;